module.exports = __webpack_public_path__ + "static/16-4f80c6f6a6ea85891b19eb897410266a.jpg";